import { Bag, ProductItem } from "@repo/apis/bag";
import { ExpandedBag } from "../utils/bag.type";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicGetProductsMethod = (bag: Bag | ExpandedBag | null) => ProductItem[];
type GetProductsMethod = BagSdkMethod<PublicGetProductsMethod>;

export const getProductsInitialiser: GetProductsMethod = () => (bag) => {
  return (
    bag?.items.filter(
      (item): item is ProductItem => item.itemType === "Product",
    ) || []
  );
};
